const propertyCreate = {
  propertyCreate: {
      meta: {
        badge: 'إدراج عقار',
        title: 'إنشاء قائمة جديدة',
        subtitle: 'قدّم جميع التفاصيل ليتمكن فريقنا من إبراز عقارك للمشترين الجادين.',
        success: {
          message: 'تم نشر العقار بنجاح.',
          viewButton: 'عرض العقار',
        },
      },
      form: {
        sections: {
          basics: 'نظرة عامة على الإعلان',
          description: 'وصف العقار',
          location: 'تفاصيل الموقع',
          media: 'الوسائط والمعرض',
          features: 'الخدمات والمرافق',
          agent: 'بيانات الوكيل',
        },
        fields: {
          title: {
            label: 'عنوان الإعلان',
            placeholder: 'مثال: فيلا بإطلالة على منتزه جدة',
          },
          price: {
            label: 'السعر (ريال)',
            placeholder: '2,450,000',
            helper: 'حوالي {{value}} لكل قدم مربع',
          },
          sqft: {
            label: 'المساحة (قدم مربع)',
            placeholder: '280',
          },
          bedrooms: {
            label: 'غرف النوم',
          },
          bathrooms: {
            label: 'دورات المياه',
          },
          propertyType: {
            label: 'نوع العقار',
          },
          yearBuilt: {
            label: 'سنة البناء',
          },
          status: {
            label: 'حالة الإعلان',
          },
          featured: 'تمييز العقار كقائمة مميزة',
          parking: 'يتوفر موقف سيارات خاص',
          petFriendly: 'مسموح بالحيوانات الأليفة',
          furnished: 'مفروش بالكامل',
          description: {
            label: 'الوصف',
            placeholder: 'شارك أبرز التفاصيل والتشطيبات والمعالم القريبة.',
          },
          address: {
            label: 'العنوان التفصيلي',
          },
          city: {
            label: 'المدينة',
          },
          state: {
            label: 'المنطقة / الحي',
          },
          zipCode: {
            label: 'الرمز البريدي',
          },
          latitude: {
            label: 'خط العرض (اختياري)',
            placeholder: '21.4858',
          },
          longitude: {
            label: 'خط الطول (اختياري)',
            placeholder: '39.1925',
          },
          imageUrl: {
            label: 'رابط صورة الغلاف',
            helper: 'ألصق رابط صورة مستضافة إذا رغبت.',
          },
          imageUpload: {
            label: 'رفع صورة الغلاف',
          },
          galleryUrls: {
            label: 'روابط صور المعرض',
            placeholder: 'https://example.com/1.jpg\nhttps://example.com/2.jpg',
          },
          galleryUpload: {
            label: 'رفع صور المعرض',
          },
          utilities: {
            label: 'الخدمات المشمولة',
            placeholder: 'الكهرباء\nالماء\nإنترنت عالي السرعة',
          },
          amenities: {
            label: 'المرافق',
            placeholder: 'مسبح بحافة متلاشية\nأنظمة منزل ذكية\nصالة سينما خاصة',
          },
          agentName: {
            label: 'اسم الوكيل',
          },
          agentPhone: {
            label: 'هاتف الوكيل',
            placeholder: 'مثال: +966 55 123 4567',
          },
          agentEmail: {
            label: 'البريد الإلكتروني للوكيل',
          },
          reset: 'إعادة تعيين النموذج',
          submit: 'نشر القائمة',
          submitting: 'جاري النشر...',
        },
      },
      validation: {
        required: 'هذا الحقل مطلوب.',
        invalidPrice: 'يرجى إدخال سعر صالح.',
        invalidArea: 'يرجى إدخال مساحة صالحة.',
        invalidBedrooms: 'يجب ألا يقل عدد غرف النوم عن صفر.',
        invalidBathrooms: 'يجب ألا يقل عدد دورات المياه عن صفر.',
        invalidYear: 'أدخل سنة بين 1900 و {{max}}.',
        invalidEmail: 'يرجى إدخال بريد إلكتروني صالح.',
        imageRequired: 'أضف صورة غلاف قبل النشر.',
        amenitiesRequired: 'أدرج ميزة واحدة على الأقل.',
        utilitiesRequired: 'أدرج خدمة واحدة على الأقل.',
        invalidLatitude: 'يجب أن تكون قيمة خط العرض بين -90 و 90.',
        invalidLongitude: 'يجب أن تكون قيمة خط الطول بين -180 و 180.',
        imageUploadFailed: 'تعذر رفع الصورة. يرجى المحاولة بملف آخر.',
        galleryUploadFailed: 'تعذر رفع صور المعرض. حاول مرة أخرى.',
        submissionError: 'تعذر نشر العقار. يرجى المحاولة مرة أخرى.',
      },
  },
};

export default propertyCreate;
